export const ONBOARDING_WELCOME_EVENTS = {
  VIEW_ONBOARDING_SCREEN: 'view_onboarding_screen',
} as const;
